<!--
 * @Description:
-->
<template>
  <div class="dashboard">
    <el-image
      :src="background"
      class="dashboard-img"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import background from '@/assets/images/home/dashboard-background.png'
export default defineComponent({
  components: {
  },
  setup() {
    return {
      background
    }
  }
})
</script>
<style lang="scss">
.dashboard {
  width: 100%;
  height: calc(100vh - 84px - 30px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.dashboard-img {
  opacity: 0.5; /* 透明度设置为50% */
}
</style>
